import { Phone, Mail, MapPin, Clock } from 'lucide-react'

export const ContactSection = () => {
  return (
    <div className="h-full flex flex-col animate-fade-in items-center justify-center p-4">
      <div className="w-full max-w-md retro-bevel-outset bg-white p-8 shadow-2xl transform rotate-1">
        <div className="border-b-2 border-black pb-4 mb-6 text-center">
          <h2 className="text-3xl font-serif font-bold uppercase tracking-widest text-black">
            Banco da Sucata
          </h2>
          <p className="text-sm font-mono mt-1 text-gray-600">
            Soluções em Reciclagem e Metais
          </p>
        </div>

        <div className="space-y-4 font-serif text-lg">
          <div className="flex items-center gap-3">
            <MapPin className="w-5 h-5" />
            <span>Av. Industrial, 1997 - São Paulo, SP</span>
          </div>
          <div className="flex items-center gap-3">
            <Phone className="w-5 h-5" />
            <span>(11) 5555-1234 / (11) 99999-9999</span>
          </div>
          <div className="flex items-center gap-3">
            <Mail className="w-5 h-5" />
            <span>contato@bancodasucata.com.br</span>
          </div>
          <div className="flex items-center gap-3 text-base text-gray-600 mt-6">
            <Clock className="w-4 h-4" />
            <span>Seg - Sex: 08:00 - 18:00</span>
          </div>
        </div>

        <div className="mt-8 text-center pt-4 border-t border-gray-300">
          <span className="font-mono text-xs text-gray-400">
            CARTÃO DE VISITA V.1.0
          </span>
        </div>
      </div>
    </div>
  )
}
